import { render, staticRenderFns } from "./FeedbackShotPicker.vue?vue&type=template&id=72da5e36&scoped=true"
import script from "./FeedbackShotPicker.vue?vue&type=script&lang=ts"
export * from "./FeedbackShotPicker.vue?vue&type=script&lang=ts"
import style0 from "./FeedbackShotPicker.vue?vue&type=style&index=0&id=72da5e36&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72da5e36",
  null
  
)

export default component.exports